import { AnalyticsService } from './analytics';
import { getAnalyticsServiceMock } from './analytics.mock';
import { isDev } from '../isDev';

export function useAnalyticsService(): AnalyticsService {
  if (isDev()) {
    return getAnalyticsServiceMock();
  }

  const analyticsService =
    window.top?.analyticsService ?? window.analyticsService;

  if (!analyticsService) {
    throw new Error('No analytics service provided');
  }

  return analyticsService;
}
